export default __webpack_public_path__ + "static/media/Meeting Type.2919f359.svg";